export default {
      id: "i-menu-research-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-menu-research",
      toString: function () {
        return this.url;
      }
    }